export default "__VITE_ASSET__DjV8Yvo0__"